<template>
  <v-dialog v-model="open" width="800">
    <v-card v-if="item">
      <v-card-title>
        Edycja walidatorów
      </v-card-title>
      <v-card-text>
        <div v-if="validators">
          <v-data-table :headers="headers" :items="validators" disable-pagination hide-default-footer>
            <template v-slot:item.type="props">
              <v-edit-dialog
                  :return-value.sync="props.item.type"
                  cancel-text="Anuluj"
                  large
                  save-text="Zapisz"
                  @save="save(props.item)">
                <template v-slot:input>
                  <v-select v-model="props.item.type" :items="propertyValidatorTypes" label="Typ walidatora"
                            large></v-select>
                </template>
                {{ propertyValidatorTypes.find(el => el.value === props.item.type).text }}
              </v-edit-dialog>
            </template>
            <template v-slot:item.value="props">
              <v-edit-dialog
                  :return-value.sync="props.item.value"
                  cancel-text="Anuluj"
                  large
                  save-text="Zapisz"
                  @save="save(props.item)">
                <template v-slot:input>
                  <v-text-field v-model="props.item.value" label="Edytuj"></v-text-field>
                </template>
              </v-edit-dialog>
            </template>
            <template v-slot:item.actions="props">
              <v-tooltip top>
                <template v-slot:activator="{on,attrs}">
                  <v-btn @click="deleteValidator(props.item)" v-bind="attrs" v-on="on" color="error"><v-icon small>fa-trash</v-icon></v-btn>
                </template>
                Usuń
              </v-tooltip>
            </template>
          </v-data-table>
        </div>
        <div v-else>
          <v-progress-circular color="primary" indeterminate></v-progress-circular>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import {propertyValidatorTypes} from "@/helpers";

export default {
  data() {
    return {
      headers: [
        {
          text: "Typ",
          value: 'type',
        },
        {
          text: "Wartość",
          value: 'value',
        },
        {
          text: "Opcje",
          value: 'actions'
        }
      ],
      open: false,
      item: null,
      validators: null,
      propertyValidatorTypes
    }
  },
  watch: {
    open: function (newVal) {
      if (!newVal) {
        this.item = null;
        this.validators = null;
      }
    }
  },
  methods: {
    showEdit(item) {
      this.item = item;
      this.open = true;
      var vm = this;
      this.$http.get("Configuration/GetValidatorsForProperty?id=" + item.id).then(response => {
        vm.validators = response.data;
      })
    },
    cancel() {
      this.open = false;
    },
    save(item) {
      this.$http.post("Configuration/SaveEditValidator", item);
    },
    deleteValidator(item) {
      var vm =this;
      this.$http.delete("Configuration/RemoveValidator?id=" + item.id).then(()=>{
        let index = vm.validators.indexOf(item);
        if (index >= 0)
        {
          vm.validators.splice(index, 1);
        }
      })
    }
  }
}
</script>
